export default __webpack_public_path__ + "static/media/Aioli-proportioned_170.1060206a.jpg";